import {
  Link,
  createRootRoute,
  HeadContent,
  Outlet,
  Scripts,
} from "@tanstack/react-router";
import appCss from "../styles/globals.css?url";
import GlobalError from "#/components/app/GlobalError";
import PostHogPageView from "#/components/app/PostHogPageView";
import Providers from "#/components/app/Providers";
import { metadataToHead } from "#/lib/seo";

const metadata = {
  metadataBase: "https://www.roamdoc.com",
  title: "Search Physician Jobs In Anesthesiology - Roamdoc",
  description: "Job search engine for physicians in anesthesiology.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: "/og-image.png",
  },
  robots: {
    index: true,
    follow: true,
    googleBot: {
      index: true,
      follow: true,
    },
  },
};

export const Route = createRootRoute({
  head: () => ({
    ...metadataToHead(metadata),
    meta: [
      { charSet: "utf-8" },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      ...metadataToHead(metadata).meta,
    ],
    links: [
      {
        rel: "stylesheet",
        href: appCss,
      },
      ...metadataToHead(metadata).links,
    ],
  }),
  component: RootComponent,
  errorComponent: GlobalError,
  notFoundComponent: NotFoundPage,
});

function RootComponent() {
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body className="font-sans">
        <Providers>
          <PostHogPageView />
          <Outlet />
        </Providers>
        <Scripts />
      </body>
    </html>
  );
}

function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-2xl flex-col items-center justify-center px-6 text-center">
      <h1 className="text-3xl font-semibold text-sky-600">Page not found</h1>
      <p className="mt-4 text-base text-gray-700">
        The page you requested does not exist.
      </p>
      <Link
        to="/"
        className="mt-6 rounded-md bg-sky-600 px-4 py-2 text-white no-underline hover:bg-sky-700"
      >
        Go to the homepage
      </Link>
    </div>
  );
}
